import React from 'react'
import Root from 'features/app/root'
import { createRoot } from 'react-dom/client'

import './assets/sass/_reset.scss'
import './assets/sass/_common.scss'
import './assets/sass/_fonts.scss'

// КРИТИЧНО: Очистка Service Worker и кэша при обновлении приложения
// Telegram WebView агрессивно кэширует - нужна принудительная очистка
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
        if (registrations.length > 0) {
            registrations.forEach(registration => {
                registration.unregister()
                console.log('🧹 Service Worker unregistered')
            })
        }
    }).catch(err => console.warn('SW unregister failed:', err))
}

// Очистка кэша
if ('caches' in window) {
    caches.keys().then(cacheNames => {
        if (cacheNames.length > 0) {
            cacheNames.forEach(cacheName => {
                caches.delete(cacheName)
                console.log('🧹 Cache deleted:', cacheName)
            })
        }
    }).catch(err => console.warn('Cache delete failed:', err))
}

createRoot(document.getElementById('root')).render(<Root />)
